import {
  CustomSectionState,
  PeoplePageSourceDerivedQuestionSectionAttributes,
} from 'api/custom-section/types';
import { PromptInputFormValues } from '../types';

export const formValuesIntoAttributes = (
  formValues: PromptInputFormValues,
  existingAttributes: PeoplePageSourceDerivedQuestionSectionAttributes,
): PeoplePageSourceDerivedQuestionSectionAttributes => {
  return {
    ...existingAttributes,
    state: CustomSectionState.Closed,
    title: formValues.title,
    config: {
      question: formValues.question,
      aiContext: formValues.aiContextChecked ? formValues.aiContext : undefined,
      groupBy: formValues.groupBy,
      generateAs: formValues.generateAs,
      sourcePageTemplates: formValues.sourcePageTemplates,
    },
  };
};
